import { I18N_AVANT_PROPERTY_LABEL_PATH } from 'constants/i18n';

export const I18N_LEASE_LABEL_PATH = `${I18N_AVANT_PROPERTY_LABEL_PATH}.leases`;
